import { render } from "./PaymentsPage.vue?vue&type=template&id=1e888c23"
import script from "./PaymentsPage.vue?vue&type=script&lang=js"
export * from "./PaymentsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__